import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { PanelDetailRouteService } from "../../../../services/Panel-Detail-Route.service";
import { PanelResumeRouteService } from "../../../../services/Panel-Resume-Route.service";
import { GroupStepRouteDTO } from "../../../../models/GroupStepRouteDTO";
import { MapHelperService } from "../../../../../../../../../services/map-helper.service";
import { StepRouteDTO } from "../../../../models/StepRouteDTO";
import { environment } from "src/environments/environment";

@Component({
  selector: "panel-detail-routeSteps",
  templateUrl: "./panel-detail-routeSteps.component.html",
  styleUrls: ["./panel-detail-routeSteps.component.css"],
})
export class PanelDetailRouteStepsComponent implements OnInit, OnDestroy {

  @Output() detailsCLicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  elements: number;
  isLoading: boolean = false;
  isVisibleDetails: boolean;
  public $isVisibleDetails: Observable<boolean> = new Observable<boolean>();
  isAdmin: boolean;
  roles: any;
  sDateRoute: string = "Detalle de Movimientos";
  selectedTabIndex: number;
  groupStepsRouteDTO: GroupStepRouteDTO[];
  groupedByDate: Map<string, GroupStepRouteDTO[]> = new Map();
  expandedDates: Set<string> = new Set();
  shownDate: string = "";
  shownFirst = false;
  isSelectedGroup: boolean = false;
  selectedGroupId: any = null;

  constructor(
    private panelDetailRouteService: PanelDetailRouteService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelperService: MapHelperService
  ) {
    this.recuperateResume();
  }

  ngOnInit(): void {}

  ngOnDestroy() {}

  recuperateResume() {
    if(!environment.production) console.log("Recuperation on progress");
    this.groupStepsRouteDTO = this.panelResumeRouteService.groupStepsRouteDTO;
    if (this.groupStepsRouteDTO) {
      this.groupStepsRouteDTO.forEach((group) => {
        
        const isEngineer = group.steps.some( step => step.typeStep === 'TrayectoEngineer' );
        if(isEngineer){
          group.typeStep = 'TrayectoEngineer';
        }
      });
      this.groupedByDate = this.getGroupsByDate();
    }
    if(!environment.production) console.log("grupos", this.groupStepsRouteDTO);
  }

  getGroupsByDate(): Map<string, GroupStepRouteDTO[]> {
    const grouped = new Map<string, GroupStepRouteDTO[]>();
    if (this.groupStepsRouteDTO) {
      this.groupStepsRouteDTO.forEach((group) => {
        const date = group.sDateGroup;
        if (!grouped.has(date)) {
          grouped.set(date, []);
          this.expandedDates.add(date);
        }
        grouped.get(date).push(group);
      });
    }
    return grouped;
  }

  getDateKeys(): string[] {
    return Array.from(this.groupedByDate.keys());
  }

  toggleDateExpansion(dateKey: string): void {
    if (this.expandedDates.has(dateKey)) {
      this.expandedDates.delete(dateKey);
    } else {
      this.expandedDates.add(dateKey);
    }
  }

  isDateExpanded(dateKey: string): boolean {
    return this.expandedDates.has(dateKey);
  }

  onClickGroup(idGroup) {
    if(!environment.production) console.log("onClickGroup", idGroup);
    this.SwitchLayerStep(idGroup);
  }

  SwitchLayerStep(idGroup) {
    if (this.selectedGroupId == idGroup) {
      this.selectedGroupId = null;
      this.isSelectedGroup = false;

      this.mapHelperService.UpdateLayerGeoJson(
        "routeGroupStep",
        this.mapHelperService.Empty_GeoJson
      );
      this.mapHelperService.ShowLayer("routeResume-line-layer");
      this.mapHelperService.HideLayer("routeResume-lineOpacityMin-layer");

      const fullRouteGeojson = this.panelResumeRouteService.resumeRouteMapDTO?.sGeojsonResume;
      if (fullRouteGeojson) {
        this.mapHelperService.FitBounds(JSON.parse(fullRouteGeojson));
      }

      this.detailsCLicked.emit(true);
      return;
    }

    const groupStep = this.groupStepsRouteDTO.filter(function (d) {
      return d.idGroup == idGroup;
    });
    if (groupStep.length > 0) {
      this.selectedGroupId = idGroup;
      this.isSelectedGroup = true;

      //Actualizar capa de Grupo
      this.mapHelperService.UpdateLayerGeoJson(
        "routeGroupStep",
        JSON.parse(groupStep[0].sGroupStepGeojson)
      );

      this.mapHelperService.FitBounds(
        JSON.parse(groupStep[0].sGroupStepGeojson)
      );
      this.mapHelperService.HideLayer("routeResume-line-layer");
      this.mapHelperService.ShowLayer("routeResume-lineOpacityMin-layer");

      this.detailsCLicked.emit(true);
    }
  }

  onClickStep(detail: StepRouteDTO, idGroup) {
    var latitude = detail.latitude;
    var longitude = detail.longitude;
    if(!environment.production) console.log("clicking step", detail);
    if(detail.statusVehicle == "Encendido" || detail.statusVehicle == "Apagado"){
      if(!environment.production) console.log("fly to", longitude,latitude);
      this.mapHelperService.FlyToCameraFast(longitude,latitude,"21");
      this.detailsCLicked.emit(true);
    }else{
      if(!environment.production) console.log("switch layer");
      this.SwitchLayerStep(idGroup);
    }
  }

  CancelButton() {
    this.panelDetailRouteService.setVisibilityPopup(false);
    if(!environment.production) console.log("cerrando popup");
  }

  getTimePeriod(time: string) {
    var hours = time.split(":")[0];
    var minutes = time.split(":")[1];

    if (Number.parseInt(hours) > 12) {
      return Number.parseInt(hours) - 12 + ":" + minutes + " PM";
    } else {
      if (Number.parseInt(hours) == 12) return hours + ":" + minutes + " PM";

      return hours + ":" + minutes + " AM";
    }
  }

  setGroupStepsRouteDate(value: string): string {
    this.shownDate = value;
    this.shownFirst = true;

    return this.shownDate;
  }

  getTypeStepLabel(typeStep: string): string {
    if (typeStep === "TrayectoEngineer") 
      return "Trayecto";
    return typeStep;
  }

  isPedestrianStep(typeStep: string): boolean {
    return typeStep === "TrayectoEngineer";
  }
}
